import { c as _c } from "react/compiler-runtime";
import { useMemberFindChangePasswordMutation } from '@module/queries/member/memberQueryHooks';
import useModalStore from '@module/stores/useModalStore';
import { MODAL_TYPE_PC } from '@module/types/modal/type';
import catchAllErrors from '@module/utils/catchAllErrors';
import { checkPw, checkPwRe } from '@module/utils/password';
import BaseButton from '@pc/components/atoms/button/BaseButton';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import './NewPasswordContainer.scss';
interface NewPasswordContainerProps {
  sessKey: string;
  pwTargetId: string;
}
function NewPasswordContainer(t0) {
  const $ = _c(36);
  const {
    sessKey,
    pwTargetId
  } = t0;
  const router = useRouter();
  const pushModal = useModalStore(_temp);
  const popModal = useModalStore(_temp2);
  const [newPw, setNewPw] = useState("");
  const [newPwRe, setNewPwRe] = useState("");
  let t1;
  if ($[0] !== popModal || $[1] !== pushModal || $[2] !== router) {
    t1 = () => {
      pushModal({
        type: MODAL_TYPE_PC.CONFIRM_MODAL,
        id: "NewPasswordContainer",
        options: {
          description: "\uC218\uC815\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
          onClose: () => {
            popModal();
            router.replace("/");
          }
        }
      });
    };
    $[0] = popModal;
    $[1] = pushModal;
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== popModal || $[5] !== pushModal) {
    t2 = err => catchAllErrors(err.message, () => {
      pushModal({
        type: MODAL_TYPE_PC.CONFIRM_MODAL,
        id: "NewPasswordContainer",
        options: {
          description: err.message,
          onClose: popModal
        }
      });
    });
    $[4] = popModal;
    $[5] = pushModal;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = {
      onSuccess: t1,
      onError: t2
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const {
    mutate
  } = useMemberFindChangePasswordMutation(t3);
  let t4;
  if ($[10] !== mutate || $[11] !== newPw || $[12] !== newPwRe || $[13] !== popModal || $[14] !== pushModal || $[15] !== pwTargetId || $[16] !== sessKey) {
    t4 = () => {
      const checkPwErrorMessage = checkPw(newPw) || checkPwRe(newPw, newPwRe);
      if (checkPwErrorMessage) {
        pushModal({
          type: MODAL_TYPE_PC.CONFIRM_MODAL,
          id: "NewPasswordContainer",
          options: {
            description: checkPwErrorMessage,
            onClose: popModal
          }
        });
        return;
      }
      mutate({
        session: sessKey,
        findId: pwTargetId,
        pw: newPw,
        pwRe: newPwRe
      });
    };
    $[10] = mutate;
    $[11] = newPw;
    $[12] = newPwRe;
    $[13] = popModal;
    $[14] = pushModal;
    $[15] = pwTargetId;
    $[16] = sessKey;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const handleButtonClick = t4;
  let t5;
  let t6;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <colgroup><col style={{
        width: "180px"
      }} /><col /></colgroup>;
    t6 = <th scope="row">신규 비밀번호</th>;
    $[18] = t5;
    $[19] = t6;
  } else {
    t5 = $[18];
    t6 = $[19];
  }
  let t7;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e => {
      setNewPw(e.currentTarget.value);
    };
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== newPw) {
    t8 = <tr>{t6}<td><input type="password" value={newPw} onChange={t7} placeholder={"8~12\uC790 \uC774\uB0B4\uC758 \uB300/\uC18C\uBB38\uC790, \uC22B\uC790, \uD2B9\uC218\uBB38\uC790"} className="w-[300px]" /></td></tr>;
    $[21] = newPw;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <th scope="row">비밀번호 재입력</th>;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = e_0 => {
      setNewPwRe(e_0.currentTarget.value);
    };
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== newPwRe) {
    t11 = <tr>{t9}<td><input type="password" value={newPwRe} onChange={t10} placeholder={"8~12\uC790 \uC774\uB0B4\uC758 \uB300/\uC18C\uBB38\uC790, \uC22B\uC790, \uD2B9\uC218\uBB38\uC790"} className="w-[300px]" /></td></tr>;
    $[25] = newPwRe;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t8) {
    t12 = <div><table className="writeTypeA">{t5}<tbody>{t8}{t11}</tbody></table></div>;
    $[27] = t11;
    $[28] = t8;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  const t13 = !newPw || !newPwRe;
  let t14;
  if ($[30] !== handleButtonClick || $[31] !== t13) {
    t14 = <div className="mt-8 flex justify-center"><BaseButton variant="primary" size="md" className="mt-10" onClick={handleButtonClick} disabled={t13}>확인</BaseButton></div>;
    $[30] = handleButtonClick;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t12 || $[34] !== t14) {
    t15 = <div className=" pb-40">{t12}{t14}</div>;
    $[33] = t12;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
}
function _temp2(state_0) {
  return state_0.popModal;
}
function _temp(state) {
  return state.pushModal;
}
export default NewPasswordContainer;